import React from "react";  

const CardComponent = (props)=>{

    function verifyHeader(header){
        if(header!==null){
            return (
                <div className="text-sm bg-gray-600 text-white py-4 px-3 rounded-t">
                    {header}
                </div>
            )
        }else{
            return (
                <div className="text-white">
                    {header}
                </div>
            )
        }
    }

    function verifyFooter(footer){
        if(footer!==null){
            return(
                <div className="text-sm bg-gray-200 text-primarydark font-roboto p-2 rounded-b-lg">
                    {footer}
                </div>
            )
        }else{
            return(
                <div className="">
                    {footer}
                </div>
            )
        }
    }
    return(
        <div className="shadow-lg rounded-lg">
            {verifyHeader(props.header)}
            <div className={'px-5 py-2 bg-white'+(props.header===null)?'rounded-t-lg ':' '+(props.footer===null)?'rounded-b-lg ':''}>
                {props.children}
            </div>
            {verifyFooter(props.footer)}
        </div>
    )
}

export default CardComponent;